import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Col, Form, Input } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { bookingCommentsInitialValues, validationSchema } from './constants';

const BookingComments = forwardRef(({ data, onDataChange }, ref) => {
  const {
    control,
    setValue,
    watch,
    trigger,
    getValues,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: bookingCommentsInitialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    shouldUnregister: false,
  });

  useImperativeHandle(ref, () => ({
    triggerAll: () => trigger(),
    triggerFields: names => trigger(names),
    getValues: () => getValues(),
    hasErrors: () => Object.keys(errors || {}).length > 0,
    focusFirstError: () => {
      const first = Object.keys(errors || {})[0];
      if (first) setFocus(first);
    },
  }));

  useEffect(() => {
    if (!data) return;
    if (data.BookingComments != null) {
      setValue('bookingComments', data.BookingComments);
    }
  }, [data, setValue]);

  const watched = watch();
  useEffect(() => {
    onDataChange?.(watched);
  }, [watched, onDataChange]);
  return (
    <div className="ba-form d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">
          <span>Booking Comments</span>
          <span className="text-danger-tr">*</span>
        </span>
      </div>
      <Form className="d-flex flex-row gap-2">
        <Col className="external-filter-col">
          <Controller
            control={control}
            name="bookingComments"
            render={({ field }) => (
              <Input
                className={`external-filter-input ${errors.bookingComments ? 'is-invalid' : ''}`}
                {...field}
                placeholder="Booking Comments"
                type="textarea"
              />
            )}
          />
          {errors.bookingComments && (
            <span className="text-danger-tr">
              {errors.bookingComments.message ||
                'Booking comments are required'}
            </span>
          )}
        </Col>
      </Form>
    </div>
  );
});

export default BookingComments;
